document.addEventListener("DOMContentLoaded", function () {
  const urlParams = new URLSearchParams(window.location.search);
  const partner = urlParams.get("partner");

  const containers = document.querySelectorAll(".typeform-container");

  // Associe chaque parametre d'url à son ID Typeform
  const partnerTypeformMap = {
    "Payplug": "01JTNB49A4REGJGJKAJSNFMG8N",
    "7724": "01JTK5NG6QZAEC7D4CNTWHE5QG",
    "ShopiMind": "01JTNB2SH7397RV1JCAA74RPEN",
    "Brevo": "01JTNAZ83FS6BFHJHRR07XFVV6",
    "PrestaShop": "01JTNAY58SA5YCTJEGS7SJ8814",
    "StoreCommander": "01JTNAX53XKBDYH64WF7YWWA11",
    "Motive": "01JTNAW6TCT6X3BXAYWYNGGT0B",
    "JLOO": "01JTNAVACGG0AN31TP31EG1R1J",
    "Arrow": "01JTNAS3RA59YVTCKY31B6F6NV",
  };

  // ID du formulaire par défaut si aucun parametre
  const defaultTypeformId = "01JNNK8FFRVQN6K2CT7HVMXRN8";
  // On vérifie si on a un partner valide, sinon on met le default
  const typeformId = partnerTypeformMap[partner] || defaultTypeformId;
  const formIdSuffix = partnerTypeformMap[partner] ? partner : "default";

  containers.forEach((container, index) => {
    const tfDiv = document.createElement("div");
    tfDiv.className = "typeform-button";
    tfDiv.id = `typeform-btn-${formIdSuffix}-${index}`;
    tfDiv.setAttribute("data-tf-live", typeformId);
    container.appendChild(tfDiv);
  });
 
   // On ajoute le script Typeform UNE SEULE FOIS
  const script = document.createElement("script");
  script.src = "//embed.typeform.com/next/embed.js";
  script.async = true;
  document.body.appendChild(script);
  }
);